/**
 * Product gallery — breakpoint mode classes, slider loop, and video flags.
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 1280px)');
  var WIDE_MQ = window.matchMedia('(min-width: 1440px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function syncGalleryMode(gallery) {
    var mobile = gallery.dataset.geGalleryMobile || 'slider';
    var desktop = gallery.dataset.geGalleryDesktop || 'slider_thumbnails';
    var mode = isDesktop() ? desktop : mobile;
    gallery.dataset.geGalleryActive = mode;
    gallery.classList.toggle('ge-product-gallery--mode-grid', mode === 'grid');
    gallery.classList.toggle('ge-product-gallery--mode-slider', mode === 'slider');
    gallery.classList.toggle('ge-product-gallery--mode-slider-thumbnails', mode === 'slider_thumbnails');
    gallery.classList.toggle('ge-product-gallery--wide-thumbs', WIDE_MQ.matches && desktop === 'slider_thumbnails');
  }

  function syncVideoFlags(gallery) {
    var desktop = isDesktop();
    gallery.querySelectorAll('.ge-gallery-video').forEach(function (wrap) {
      var loop = desktop
        ? wrap.dataset.geVideoLoopDesktop === 'true'
        : wrap.dataset.geVideoLoopMobile === 'true';
      var autoplay = desktop
        ? wrap.dataset.geVideoAutoplayDesktop === 'true'
        : wrap.dataset.geVideoAutoplayMobile === 'true';
      var video = wrap.querySelector('video');
      if (video) {
        video.loop = loop;
        if (autoplay) {
          video.muted = true;
          video.play().catch(function () {});
        } else {
          video.pause();
          video.autoplay = false;
        }
      }
    });
  }

  function syncFlickityLoop(gallery) {
    var slider = gallery.querySelector('product-slider-thumbnails');
    if (!slider || !window.Flickity) return;
    if (typeof slider.reInit === 'function') {
      slider.reInit();
      return;
    }
    var flkty = Flickity.data(slider);
    if (!flkty) return;
    var loop = isDesktop()
      ? gallery.dataset.geLoopDesktop === 'true'
      : gallery.dataset.geLoopMobile === 'true';
    flkty.options.wrapAround = loop;
    flkty.updateDraggable();
  }

  function bindGallery(gallery) {
    if (gallery.dataset.geGalleryBound === 'true') return;
    gallery.dataset.geGalleryBound = 'true';
    var refresh = function () {
      syncGalleryMode(gallery);
      syncVideoFlags(gallery);
      syncFlickityLoop(gallery);
    };
    refresh();
    DESKTOP_MQ.addEventListener('change', refresh);
    WIDE_MQ.addEventListener('change', refresh);
  }

  function init() {
    document.querySelectorAll('.ge-product-gallery').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
